export default __webpack_public_path__ + "static/media/alliedHangers1.0daaaf0d.jpg";